import { AJAX_TIMEOUT_MESSAGE } from './helpers.js';
import { renderShabbosScreen } from './shabbos-screen.js';
import { showAlertMsg } from './members/member-show-alert-msg.js';
import { cleanupBootstrapModalBody } from './shared/bootstrap-modal-cleanup.js';

const TWILIO_TOKEN_REFRESH_MS = 1800000;
const TWILIO_STARTUP_RETRY_MS = 30000;

let voiceCallActive = false;
let twilioDevice = null;
let twilioToken = null;
let twilioTokenRefreshIntervalId = null;
let twilioStartupRetryTimeoutId = null;

export function isVoiceCallActive() {
    return voiceCallActive;
}

function cancelPendingTwilioStartupRetry() {
    if (!twilioStartupRetryTimeoutId) {
        return;
    }
    clearTimeout(twilioStartupRetryTimeoutId);
    twilioStartupRetryTimeoutId = null;
}

export function teardownShabbosPage() {
    cancelPendingTwilioStartupRetry();

    if (twilioTokenRefreshIntervalId) {
        clearInterval(twilioTokenRefreshIntervalId);
        twilioTokenRefreshIntervalId = null;
    }

    if (twilioDevice) {
        try {
            twilioDevice.destroy();
        } catch (error) {
            console.error(error);
        }
        twilioDevice = null;
    }

    twilioToken = null;
    voiceCallActive = false;
}

export function initShabbosPage(cfg, options) {
    let call = null;
    let startupInProgress = false;

    cancelPendingTwilioStartupRetry();

    $('#show_ambulance').hide();
    $('#show_911').hide();
    $('#hang_up_call').hide();
    cleanupBootstrapModalBody();

    renderShabbosScreen(cfg.bgImageUrl, options);

    $(document).off('click.shabbosPhoneModal').on('click.shabbosPhoneModal', '[data-action="open-phone-modal"]', function () {
        openPhoneModal($(this).attr('data-call-type'));
    });

    $(document).off('click.shabbosPhoneActions')
        .on('click.shabbosPhoneActions', '[data-action="close-emergency-modal"]', function () {
            closeEmergencyModal();
        })
        .on('click.shabbosPhoneActions', '[data-action="run-call-hangup"]', function () {
            runCallHangup();
        });

    initEmergencySlider();
    startupClient();

    function initEmergencySlider() {
        const $slider = $('.emer_slider');
        let initialMouse = 0;
        let slideMovementTotal = 0;
        let mouseIsDown = false;

        $('#hangup_button').hide();

        $slider.on('mousedown touchstart', function (event) {
            mouseIsDown = true;
            slideMovementTotal = $(this).parent().width() - $(this).width() + 10;
            initialMouse = event.clientX || event.originalEvent.touches[0].pageX;
        });

        $(document.body)
            .off('mouseup.emerSlider touchend.emerSlider')
            .on('mouseup.emerSlider touchend.emerSlider', function (event) {
                if (!mouseIsDown) return;
                mouseIsDown = false;
                const currentMouse = event.clientX || event.changedTouches[0].pageX;
                const relativeMouse = currentMouse - initialMouse;

                if (relativeMouse < slideMovementTotal) {
                    $('.slide-text').fadeTo(300, 1);
                    $slider.animate({ left: '-10px' }, 300);
                    return;
                }
                makeOutgoingCall();
            });

        $(document.body)
            .off('mousemove.emerSlider touchmove.emerSlider')
            .on('mousemove.emerSlider touchmove.emerSlider', function (event) {
                if (!mouseIsDown) return;

                const currentMouse = event.clientX || event.originalEvent.touches[0].pageX;
                const relativeMouse = currentMouse - initialMouse;
                const slidePercent = 1 - (relativeMouse / slideMovementTotal);

                $('.slide-text').fadeTo(0, slidePercent);

                if (relativeMouse <= 0) {
                    $slider.css({ left: '-10px' });
                    return;
                }
                if (relativeMouse >= slideMovementTotal + 10) {
                    $slider.css({ left: slideMovementTotal + 'px' });
                    return;
                }
                $slider.css({ left: relativeMouse - 10 });
            });
    }

    function openPhoneModal(callType) {
        $('#callType').val(callType);
        if (callType === '911') {
            $('#call_emer_header').html('Call 911');
            $('#show_911').show();
            $('#show_ambulance').hide();
        } else {
            $('#call_emer_header').html('Call Ambulance');
            $('#show_ambulance').show();
            $('#show_911').hide();
        }
        $('#phoneSwipeModal').modal('show');
    }

    function fetchTwilioToken() {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: cfg.twilioTokenUrl,
                type: 'GET',
                timeout: 10000,
                data: {
                    url_slug: cfg.twilioUrlSlug || '',
                    kiosk_name: cfg.twilioKioskName || '',
                    sig: cfg.twilioTokenSig || '',
                    _token: cfg.csrfToken,
                },
                success: function (data) {
                    if (!data.token) {
                        reject('Error getting dialing token, please refresh this window to try again');
                    } else {
                        resolve(data.token);
                    }
                },
                error: function () {
                    reject(AJAX_TIMEOUT_MESSAGE);
                },
            });
        });
    }

    async function refreshTwilioToken() {
        try {
            const newToken = await fetchTwilioToken();
            twilioToken = newToken;
            if (twilioDevice) {
                twilioDevice.updateToken(newToken);
            }
        } catch (err) {
            showAlertMsg('Error refreshing Twilio token: ' + err, 'danger');
        }
    }

    async function startupClient() {
        if (startupInProgress) return;
        startupInProgress = true;
        cancelPendingTwilioStartupRetry();
        twilioDevice = null;
        twilioToken = null;

        try {
            try {
                twilioToken = await fetchTwilioToken();
            } catch (firstErr) {
                await new Promise(function (r) { setTimeout(r, 3000); });
                twilioToken = await fetchTwilioToken();
            }

            initializeDevice();

            if (twilioTokenRefreshIntervalId) {
                clearInterval(twilioTokenRefreshIntervalId);
            }
            twilioTokenRefreshIntervalId = setInterval(refreshTwilioToken, TWILIO_TOKEN_REFRESH_MS);
        } catch (err) {
            showAlertMsg('Error starting phone system, retrying shortly', 'danger');
            twilioStartupRetryTimeoutId = setTimeout(startupClient, TWILIO_STARTUP_RETRY_MS);
        } finally {
            startupInProgress = false;
        }
    }

    function initializeDevice() {
        if (typeof Twilio === 'undefined' || !Twilio.Device) {
            throw new Error('Twilio SDK unavailable');
        }
        twilioDevice = new Twilio.Device(twilioToken, {
            logLevel: 3,
            codecPreferences: ['opus', 'pcmu'],
            closeProtection: false,
            sounds: { incoming: cfg.ringtoneUrl },
        });
        addDeviceListeners();
        twilioDevice.register();
    }

    function addDeviceListeners() {
        twilioDevice.on('error', function (error) {
            showAlertMsg('Twilio device error, please refresh this window to reset', 'danger');
            console.log('twilio error: ' + error);
        });
        twilioDevice.on('incoming', handleIncomingCall);
    }

    function handleIncomingCall(incomingCall) {
        const rawFrom = incomingCall.parameters && incomingCall.parameters.From;
        const digits = rawFrom ? rawFrom.replace(/\D/g, '') : '';
        const showPhone = digits.length >= 11
            ? digits.substring(1, 4) + '-' + digits.substring(4, 7) + '-' + digits.substring(7, 11)
            : (rawFrom || 'Unknown');

        const acceptBtn = document.getElementById('accept_call');
        const rejectBtn = document.getElementById('reject_call');
        const hangupBtn = document.getElementById('hang_up_call');
        if (acceptBtn) acceptBtn.onclick = function () { acceptIncomingCall(incomingCall); };
        if (rejectBtn) rejectBtn.onclick = function () { rejectIncomingCall(incomingCall); };
        if (hangupBtn) hangupBtn.onclick = function () { hangupIncomingCall(incomingCall); };

        incomingCall.on('disconnect', handleDisconnectedIncomingCall);
        incomingCall.on('cancel', handleDisconnectedIncomingCall);

        $('#show_incoming_info').text(showPhone);
        $('#IncomingCallModal').modal('show');
    }

    function acceptIncomingCall(incomingCall) {
        incomingCall.accept();
        voiceCallActive = true;
        $('#accept_call').hide();
        $('#reject_call').hide();
        $('#hang_up_call').show();
    }

    async function makeOutgoingCall() {
        if (voiceCallActive || call) {
            return;
        }
        if (!twilioDevice) {
            showAlertMsg('Device not ready, please try again', 'danger');
            return;
        }
        try {
            const twilioNumber = '+1' + $('#twilio_number').val().replace(/\D/g, '');
            const numberToCall = '+1' + ($('#callType').val() === 'ambulance'
                ? $('#hatzalah_phone').val()
                : $('#emergency_phone').val()
            ).replace(/\D/g, '');

            call = await twilioDevice.connect({
                params: { number_to_call: numberToCall, number_from: twilioNumber, call_type: 'outgoing' },
            });

            $('.emer_slider').css('left', '').addClass('unlock_me');
            $('.slider-red').html('Calling Ambulance');
            $('.slider-blue').html('Calling 911');
            $('#close_modal_button').hide();
            $('#phoneSwipeModal').prop('onclick', null).off('click');
            $('#hangup_button').show();

            call.on('accept', updateUIAcceptedOutgoingCall);
            call.on('disconnect', updateUIDisconnectedOutgoingCall);
            voiceCallActive = true;
        } catch (err) {
            call = null;
            showAlertMsg('Failed to connect call, please try again', 'danger');
        }
    }

    function runCallHangup() {
        $('#hangup_button').hide();
        if (call) {
            call.disconnect();
            call = null;
        }
    }

    function updateUIAcceptedOutgoingCall() {
        $('.slider-red').html('Dispatcher will end call when completed');
        $('.slider-blue').html('Dispatcher will end call when completed');
    }

    function updateUIDisconnectedOutgoingCall() {
        $('#hangup_button').hide();
        call = null;
        closeEmergencyModal();
    }

    function closeEmergencyModal() {
        voiceCallActive = false;
        call = null;
        const $slider = $('.emer_slider');
        $('.slide-text').fadeTo(300, 1);
        $slider.animate({ left: '-10px' }, 300);
        $('.slider-red').html('<i id="locker_ambulance" class="fa-light fa-truck-medical fa-2x"></i>');
        $('.slider-blue').html('<i id="locker_911" class="fa-regular fa-light-emergency-on fa-2x"></i>');
        $slider.removeClass('unlock_me');
        $('#close_modal_button').show();
        $('#phoneSwipeModal').modal('hide');
    }

    function closeAnswerModal() {
        voiceCallActive = false;
        $('#accept_call').show();
        $('#reject_call').show();
        $('#hang_up_call').hide();
        $('#show_incoming_info').text('');
        $('#IncomingCallModal').modal('hide');
    }

    function rejectIncomingCall(incomingCall) {
        incomingCall.reject();
        closeAnswerModal();
    }

    function hangupIncomingCall(incomingCall) {
        incomingCall.disconnect();
        closeAnswerModal();
    }

    function handleDisconnectedIncomingCall() {
        closeAnswerModal();
    }
}
